import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { toastNotificationsService } from 'src/config/rootService';

const SingleSignOnFailed: React.FC = () => {
    useEffect(() => toastNotificationsService.renderErrorToast('notifications.ssoFailed'), []);

    return <Redirect to="/" />;
};

export default SingleSignOnFailed;
